<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"    

    :value="component_value"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" 
        :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      >{{labeltext}}</div>
      <div ref="container_input" class="grccomp_container_input">
        <input ref="dateinput" type="text" class="grc-input" inputmode="numeric"
        v-model="display_text" 
        @input="onInput" 
        @blur="onInputBlur" 
        @focus="onInputFocus($event)" 
        @keydown="onInputKeydown"
        :readonly="readonly == 'true'"
        v-bind:placeholder="placeholder" />

      </div>
    </div>

    <GrcCompErrorBubble ref="ErrorBubble" />
  </div>
</template>

<script>

import Vue from 'vue'
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'

export default {
  name: 'GrcMobilszam',
  components:
  {
    GrcCompErrorBubble
  },
  props: {
    value: String,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String
  },
  data () {
    return {
        component_value: "",
        prev_component_value: "",

        display_text: "",
        prev_display_text: "",         

        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        comp_focused: false,
        value_on_focus: "",
    }
  },
  watch : {
    value (pNewValue) {
        var onlyNum = pNewValue.replace(/[^0-9]+/g, '');

      if (pNewValue !== this.prev_component_value) {
          this.DisplayValue(pNewValue);
          if (onlyNum != this.component_value)
          {
            this.prev_component_value = onlyNum;
            this.component_value = onlyNum;
            this.$emit('input', this.component_value);
          }

      }
    },

    display_text()
    {
        if (this.comp_focused == false) { return; }
        if (this.display_text != this.prev_display_text)
        {
            if (this.CheckText(this.display_text) == false)
            {
                this.display_text = this.prev_display_text;
            }
            else
            {
                this.prev_display_text = this.display_text;
            }
        }
    }
  },

  created: function()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }


    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }

    if (typeof this.value != "undefined")
    {
      this.prev_component_value = this.value;
      this.component_value = this.value;
      this.DisplayValue(this.component_value);
    }


  },
  computed: {
  },
  methods: {

    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },

    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      //var repchars = "[^0-9-]+";
      var seps = "-";
      var repchars = "[^0-9"+seps+"]+";
      var regex = new RegExp(repchars, "g");
      var cv = pText.replace(regex, "");

      if (cv != pText) { CheckOK = false; }
      
      var onlyNum = pText.replace(/[^0-9]+/g, '');

      if (cv.length - onlyNum.length > 3) { CheckOK = false; } // több mint 3 separator
      if (onlyNum.length > 11) { CheckOK = false; } // 11 szamjegynel tobb

      return CheckOK;
    },

    FormatText: function(pText)
    {
      if (pText == null) { pText = ""; }

      var onlyNum = pText.replace(/[^0-9]+/g, '');

      var res = "";

      if (onlyNum == "") { res = ""; }
      else
      {
        onlyNum = onlyNum.padEnd(11, ' ');

        res = onlyNum.substr(0, 2)+"-"+onlyNum.substr(2, 2)+"-"+onlyNum.substr(4, 3)+"-"+onlyNum.substr(7, 4);

        res = res.replace(/ /g, '');
      }

      return res;
    },

    onInputBlur()
    {
      if (this.IsReadonly()) 
      {
        this.$emit('grc-blur');
        return;
      }

      var s = this.FormatText(this.display_text);
      
      if (this.readonly != true)
      {
        s = s.replace(/[ ]+/g, '');
      }

      this.component_value = this.display_text.replace(/[^0-9]+/g, '');

      var ValueChanged = (this.component_value != this.value_on_focus);

      this.comp_focused = false;

      if (ValueChanged)
      {
        this.$emit('input', this.component_value);
      }
      else
      {
        this.prev_component_value = this.component_value;
      }

      this.DisplayValue(this.component_value);          

      this.$emit('grc-blur');

    },

    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
    },

    onInputKeydown(e)
    {
      if ((e.keyCode == 13) || (e.keyCode == 9)) {}
      else
      {
        this.$refs.ErrorBubble.HideError();
      }

      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
      }
    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      this.value_on_focus = this.component_value;

      if (this.IsReadonly() == false)
      {
        this.prev_display_text = this.component_value;
        this.display_text = this.component_value;
      }

        Vue.nextTick(function () {
            //e.target.select();
        });      
      this.$emit('grc-focus');
    },

    SetFocus()
    {
      this.$refs.dateinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    SetText(pText)
    {
      pText = pText.replace(/[^0-9]+/g, '');

      this.prev_component_value = pText;
      this.component_value = pText;
      this.DisplayValue(this.component_value);
      this.$emit('input', this.component_value);
    },

    GetText()
    {
      return this.component_value;
    }


    
  }
}
</script>

<style scoped>


</style>